var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9.48,
    viewBox: "0 0 16 9.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#484848;}.b{stroke:#f8f8f8;}.c{stroke:none;}.d{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,0c4.418,0,8,4.035,8,4.74S12.418,9.48,8,9.48,0,5.492,0,4.74C0,4,3.582,0,8,0Z",
    transform: "translate(0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(5 1.74)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 3,
    cy: 3,
    r: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.8ed218bb43050bd2c0053b95c4e15ae1.svg";
export { ForwardRef as ReactComponent };